import { render, staticRenderFns } from "./set-dimension.vue?vue&type=template&id=4d86770c&scoped=true"
import script from "./set-dimension.vue?vue&type=script&lang=ts"
export * from "./set-dimension.vue?vue&type=script&lang=ts"
import style0 from "./set-dimension.vue?vue&type=style&index=0&id=4d86770c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d86770c",
  null
  
)

export default component.exports